import { getUploadModel } from '../../constants';

export const rotateNext = async (upload, nexts) => {
  if (!upload?.id) {
    throw new Error('rotate: upload.id is missing');
  }

  const nextOrientation = nexts[upload.orientation];

  if (!nextOrientation) return;

  const model = getUploadModel();

  // TODO est-ce vraiment besoin ?? upload n'est-il pas un objet ?
  const result = await model.find(upload.id);
  const record = result?.data;

  if (!record) {
    throw new Error(`changeOrientation: Upload ${upload.id} not found`);
  }

  record.orientation = nextOrientation;
  return record.commit();
};
